import {NullableKeys} from '@fl/cmsch-fe-library';
import {genNakedPropOrCrash, opt} from 'ts-opt';

import {CreateOrUpdateRole} from 'api/gen/CreateOrUpdateRole';
import {State} from 'app/setup';
import {formHelpers} from 'utils/forms';

import {roleFormName} from '../types';

/**
 * Builds the API payload for a role form submission.
 *
 * @param formValues Role form values.
 * @returns API payload for a role.
 */
export const buildRoleValuesForApi = (formValues: NullableKeys<CreateOrUpdateRole>): CreateOrUpdateRole => {
    const get = genNakedPropOrCrash(formValues);

    return {
        code: get('code'),
        name: get('name'),
        discriminatorId: get('discriminatorId'),
        userEnable: opt(formValues).prop('userEnable').orFalse(),
    };
};

/**
 * Reads the role form values from Redux state.
 *
 * @param state Redux state.
 * @returns Role form values if present.
 */
export const getRoleFormValues = (state: State): NullableKeys<CreateOrUpdateRole> =>
    formHelpers.formValues(roleFormName)(state).orCrash('no role form values');
